import { AppConfig } from '../../../app-config'
import getUserDetails from '../../../utils/actions/getUserDetails'
import { getLeadSource } from '../../../utils/analytics/leadSourceHelper'
import { triggerSimpleAjax } from '../../../utils/http-helper'

const API_URL = AppConfig.api_url

export default ({
	reqObj = {},
	router,
	lastLocation,
	eventProps = {},
	dispatch,
}) => {
	let url = `${API_URL}user/verifyotplogin`
	return new Promise((resolve, reject) => {
		triggerSimpleAjax({
			url,
			method: 'POST',
			body: reqObj,
			onSuccess: response => {
				if (response.status === 'VERIFIED') {
					const leadSource = getLeadSource({
						router,
						lastLocation,
					})
					eventProps.prod_type = leadSource?.prodType
					getUserDetails({
						req_data: { prod_type: leadSource.prodType },
						dispatch,
					})
						.then(userDetails => {
							resolve({
								status: response.status,
								user: userDetails,
								router,
							})
						})
						.catch()
				} else {
					reject(response)
				}
			},
			onFailure: error => {
				reject(error)
			},
		})
	})
}
